export default "__VITE_ASSET__C1g5PvLi__"